import theme from '@ifca-root/react-component/src/assets/theme'
import {
  Divider,
  Grid,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React from 'react'

export const ARItemDetailContent = (props: any) => {
  const { listItem, is_einvoice } = props
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      <div className="rm-padding table-wrap ">
        <Grid container className="table-content">
          <Grid
            component="span"
            item
            xs={1}
            className="fw-thin desc"
            style={{ color: 'grey' }}
          >
            No.
          </Grid>
          <Grid
            component="span"
            item
            xs={8}
            className="fw-thin desc flex-space"
            style={{ color: 'grey' }}
          >
            Item
          </Grid>
          <Grid
            component="span"
            item
            xs={3}
            className="right-text fw-thin desc"
            style={{ color: 'grey' }}
          >
            Amt
          </Grid>
        </Grid>
        {listItem
          ?.filter(x => x?.DocAmt !== 0)
          ?.map((el, index) => {
            return (
              <>
                <ListItem className="table-listItem" key={index} divider>
                  <Grid container>
                    <ListItemText
                      primary={
                        <>
                          <Grid container>
                            <Grid item xs={1} component="span">
                              <span className="desc text-noflow">
                                {index + 1}.
                              </span>
                            </Grid>
                            <Grid item xs={8} component="span">
                              <span className="xxTitle text-noflow">
                                {el?.BillItem?.Name}
                              </span>
                            </Grid>
                            <Grid
                              item
                              xs={3}
                              component="span"
                              className="right-text"
                            >
                              <span className="xxTitle">
                                {amtStr(el?.DocAmt)}
                              </span>
                            </Grid>
                          </Grid>
                        </>
                      }
                      secondary={
                        <>
                          {el?.SalesOrderID && (
                            <Grid container component="span">
                              <Grid item xs={1} component="span"></Grid>
                              <Grid
                                item
                                xs={11}
                                component="span"
                                className="desc flex-space"
                              >
                                <div className="desc text-noflow">
                                  Contract:
                                  <span className="p-l-3 desc text-noflow">
                                    {el?.SalesOrder?.title} |{' '}
                                    {el?.SalesOrder?.salesType}
                                  </span>
                                </div>
                              </Grid>
                            </Grid>
                          )}
                          <Grid container component="span">
                            <Grid item xs={1} component="span"></Grid>
                            <Grid
                              item
                              xs={11}
                              component="span"
                              className="desc flex-space"
                            >
                              <div className="desc text-noflow">
                                Base Amt:
                                <span className="p-l-3 desc text-noflow">
                                  {amtStr(el?.Amount)}
                                </span>
                              </div>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={1} component="span"></Grid>
                            <Grid item xs={11} component="div">
                              <span className="desc text-noflow">
                                Tax Amount:
                              </span>
                              <span className="p-l-3 desc text-noflow">
                                {amtStr(el?.TaxAmt) +
                                  ` | ` +
                                  el?.TaxScheme?.Name +
                                  ` `}
                              </span>
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid item xs={1} component="span"></Grid>
                            <Grid item xs={11} component="div">
                              <span className="desc text-noflow">
                                {el?.CostCentre?.Code}
                              </span>
                            </Grid>
                          </Grid>

                          {/* Third Row */}

                          {is_einvoice && (
                            <Grid container>
                              <Grid item xs={1} component="span"></Grid>
                              <Grid item xs={11} component="div">
                                <div className="desc text-noflow">
                                  {`${el?.ClassificationCode?.classificationCode}(${el?.ClassificationCode?.description})`}
                                </div>
                              </Grid>
                            </Grid>
                          )}
                          <Grid container>
                            <Grid item xs={1} component="span"></Grid>
                            <Grid item xs={11} component="div">
                              <div className="desc text-noflow">
                                {el?.Remark ?? ''}
                              </div>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={1} component="span"></Grid>
                            <Grid item xs={11} component="div">
                              <div className="desc text-noflow">
                                {!!el?.BillItem?.MasterCOA?.MasterCOAID
                                  ? `${el.BillItem.MasterCOA.Code} | ${el.BillItem.MasterCOA.Name}`
                                  : ''}
                              </div>
                            </Grid>
                          </Grid>
                        </>
                      }
                    />
                  </Grid>
                </ListItem>

                {index !== listItem?.length - 1 && (
                  <Divider
                    variant="fullWidth"
                    style={{ background: '#E4E4E4' }}
                  />
                )}
              </>
            )
          })}
      </div>
      <div className="footer-label" style={{ background: '#bfd3ff' }} />
    </>
  )
}
